/*
 * Ocean Racing — Free Shipping Bar
 * Built by North Track Digital
 *
 * Responsibilities:
 *   1. Variant selection on booster cards (swatches / swatch+size / dropdown).
 *   2. Quick-add, resolving the exact variant.
 *   3. Keeping the bar truthful after any cart change.
 *   4. curate() — recommendation-ranked, cart-aware card selection with a
 *      "Show more" expansion over the server-rendered pool.
 *
 * No requestAnimationFrame / CSS-transition dependencies (observed frozen in
 * embedded contexts). Timers only.
 */
(function () {
  'use strict';

  if (window.__oceanFsBar) return;
  window.__oceanFsBar = true;

  var BAR_SECTION = 'free-shipping-bar-section';
  var SLOT = '[data-fs-bar-slot]';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cartFooter() {
    return document.getElementById('main-cart-footer');
  }

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function swapSection(sectionName, targetId) {
    return fetch(root() + '?section_id=' + sectionName, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = parse(html);
        var src = doc.querySelector('.shopify-section') || doc.body;
        var target = document.getElementById(targetId);
        if (target && src) target.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- 1. Variant selection ---------- */

  function cardVariants(card) {
    var tag = card.querySelector('[data-fs-variants]');
    if (!tag) return null;
    try { return JSON.parse(tag.textContent); } catch (e) { return null; }
  }

  function selectedSwatchValue(card) {
    var sel = card.querySelector('[data-fs-swatch].is-selected');
    return sel ? sel.getAttribute('data-fs-option-value') : null;
  }

  function resolveTwoOption(card) {
    var variants = cardVariants(card);
    if (!variants) return;
    var swatchIdx = card.getAttribute('data-fs-swatch-index') === '2' ? 'o2' : 'o1';
    var otherIdx = swatchIdx === 'o1' ? 'o2' : 'o1';
    var colour = selectedSwatchValue(card);
    var select = card.querySelector('[data-fs-option2]');
    if (!colour || !select) return;

    var exact = variants.find(function (v) { return v[swatchIdx] === colour && v[otherIdx] === select.value; });
    var chosen = exact || variants.find(function (v) { return v[swatchIdx] === colour; });
    if (!chosen) return;

    if (!exact) select.value = chosen[otherIdx];
    card.dataset.fsSelected = String(chosen.id);

    var img = card.querySelector('[data-fs-card-image]');
    if (img && chosen.img) {
      img.removeAttribute('srcset');
      img.src = chosen.img;
    }
    var label = card.querySelector('[data-fs-chosen]');
    if (label) label.textContent = chosen.o1 + ' / ' + chosen.o2;
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-fs-swatch]');
    if (!swatch) return;
    event.preventDefault();

    var card = swatch.closest('.fs-bar__card');
    if (!card) return;

    Array.prototype.forEach.call(card.querySelectorAll('[data-fs-swatch]'), function (b) {
      b.classList.remove('is-selected');
      b.setAttribute('aria-checked', 'false');
    });
    swatch.classList.add('is-selected');
    swatch.setAttribute('aria-checked', 'true');

    if (card.hasAttribute('data-fs-swatch-index')) {
      resolveTwoOption(card);
      return;
    }

    card.dataset.fsSelected = swatch.getAttribute('data-fs-swatch');

    var image = card.querySelector('[data-fs-card-image]');
    var newSrc = swatch.getAttribute('data-fs-swatch-image');
    if (image && newSrc) {
      image.removeAttribute('srcset');
      image.src = newSrc;
    }

    var chosen = card.querySelector('[data-fs-chosen]');
    if (chosen) chosen.textContent = swatch.getAttribute('aria-label') || '';
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-fs-option2]');
    if (!select) return;
    var card = select.closest('.fs-bar__card');
    if (card) resolveTwoOption(card);
  });

  /* ---------- Refresh helpers ---------- */

  var refreshing = false;

  function refreshPopupBar() {
    var slots = [].filter.call(document.querySelectorAll(SLOT), function (s) {
      return !s.closest('#main-cart-footer') && !s.closest('cart-drawer');
    });
    if (!slots.length || refreshing) return Promise.resolve();
    refreshing = true;

    return fetch(root() + '?section_id=' + BAR_SECTION, { headers: { Accept: 'text/html' } })
      .then(function (r) {
        if (!r.ok) throw new Error('section fetch failed');
        return r.text();
      })
      .then(function (html) {
        var fresh = parse(html).querySelector('.fs-bar');
        slots.forEach(function (slot) {
          slot.innerHTML = fresh ? fresh.outerHTML : '';
        });
      })
      .catch(function () {})
      .finally(function () {
        refreshing = false;
      });
  }

  function refreshCartPage() {
    var items = document.getElementById('main-cart-items');
    var footer = cartFooter();
    var targets = [];
    if (items && items.dataset.id) targets.push([items, items.dataset.id]);
    if (footer && footer.dataset.id) targets.push([footer, footer.dataset.id]);

    var ids = targets.map(function (t) { return t[1]; }).concat(['cart-icon-bubble']);

    return fetch(root() + '?sections=' + encodeURIComponent(ids.join(',')))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        targets.forEach(function (pair) {
          var el = pair[0];
          var markup = sections[pair[1]];
          if (!markup) return;
          var fresh = parse(markup).querySelector('.js-contents');
          var target = el.querySelector('.js-contents');
          if (fresh && target) target.innerHTML = fresh.innerHTML;
          el.classList.remove('is-empty');
        });
        if (sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          var doc = parse(sections['cart-icon-bubble']);
          var src = doc.querySelector('.shopify-section') || doc.body;
          if (bubble && src) bubble.innerHTML = src.innerHTML;
        }
      });
  }

  /* ---------- 2. Quick-add ---------- */

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-fs-add]');
    if (!btn) return;
    event.preventDefault();
    if (btn.hasAttribute('aria-busy')) return;

    var card = btn.closest('.fs-bar__card');
    var fullSelect = card ? card.querySelector('[data-fs-variant]') : null;

    var variantId =
      (fullSelect && fullSelect.value) ||
      (card && card.dataset.fsSelected) ||
      btn.getAttribute('data-fs-add');
    if (!variantId) return;

    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding…';

    var onCart = !!cartFooter();
    var drawer = document.querySelector('cart-drawer');
    var useDrawer = !onCart && drawer && typeof drawer.renderContents === 'function';

    var body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (useDrawer) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || state.message || 'add failed');
        if (onCart) return refreshCartPage();
        if (useDrawer) return drawer.renderContents(state);
        return Promise.all([
          refreshPopupBar(),
          swapSection('cart-icon-bubble', 'cart-icon-bubble'),
          swapSection('cart-notification-button', 'cart-notification-button')
        ]);
      })
      .catch(function () {
        window.location.href = root() + 'cart';
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
      });
  });

  /* ---------- 4. Recommendation-driven curation + Show more ---------- */

  var recCache = {};

  function fetchRecs(productId) {
    if (recCache[productId]) return Promise.resolve(recCache[productId]);
    var base = root() + 'recommendations/products.json?limit=6&product_id=' + productId;
    return fetch(base + '&intent=complementary')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var ids = (data.products || []).map(function (p) { return p.id; });
        if (ids.length >= 3) return ids;
        return fetch(base + '&intent=related')
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (rel) {
            (rel.products || []).forEach(function (p) {
              if (ids.indexOf(p.id) === -1) ids.push(p.id);
            });
            return ids;
          });
      })
      .then(function (ids) {
        recCache[productId] = ids;
        return ids;
      })
      .catch(function () { return []; });
  }

  var curating = false;

  function curate() {
    var bars = [].filter.call(document.querySelectorAll('.fs-bar'), function (b) {
      return b.querySelectorAll('.fs-bar__card').length > 0;
    });
    if (!bars.length || curating) return;
    curating = true;

    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = {};
        (cart.items || []).forEach(function (i) { inCart[i.product_id] = true; });

        var seedIds = (cart.items || [])
          .slice()
          .sort(function (a, b) { return b.final_line_price - a.final_line_price; })
          .slice(0, 2)
          .map(function (i) { return i.product_id; });

        return Promise.all(seedIds.map(fetchRecs)).then(function (lists) {
          var rank = {};
          var idx = 0;
          var maxLen = lists.reduce(function (m, l) { return Math.max(m, l.length); }, 0);
          for (var i = 0; i < maxLen; i++) {
            lists.forEach(function (l) {
              if (i < l.length && rank[l[i]] === undefined) rank[l[i]] = idx++;
            });
          }
          return { inCart: inCart, rank: rank };
        });
      })
      .then(function (ctx) {
        bars.forEach(function (bar) { rankBar(bar, ctx); });
      })
      .catch(function () {})
      .finally(function () {
        curating = false;
      });
  }

  function rankBar(bar, ctx) {
    var remaining = parseInt(bar.getAttribute('data-fs-remaining'), 10);
    if (!(remaining > 0)) return;
    var list = bar.querySelector('.fs-bar__list');
    if (!list) return;

    var cards = [].map.call(list.querySelectorAll('.fs-bar__card'), function (el) {
      return {
        el: el,
        product: parseInt(el.getAttribute('data-fs-product'), 10),
        price: parseInt(el.getAttribute('data-fs-price'), 10)
      };
    });

    var BIG = 1e9;
    function recRank(c) {
      return ctx.rank[c.product] !== undefined ? ctx.rank[c.product] : BIG;
    }

    var fresh = cards.filter(function (c) { return !ctx.inCart[c.product]; });
    var repeats = cards.filter(function (c) { return ctx.inCart[c.product]; });

    function pick(pool) {
      var unlockers = pool.filter(function (c) { return c.price >= remaining; });
      var partials = pool.filter(function (c) { return c.price < remaining; });
      unlockers.sort(function (a, b) {
        return (recRank(a) - recRank(b)) || (a.price - b.price);
      });
      partials.sort(function (a, b) {
        return (recRank(a) - recRank(b)) || (b.price - a.price);
      });
      return unlockers.concat(partials);
    }

    bar.__fsRanked = pick(fresh).concat(pick(repeats));
    applyRanked(bar);
  }

  // Visibility application, shared by curation and the Show-more button.
  function applyRanked(bar) {
    var ranked = bar.__fsRanked;
    if (!ranked || !ranked.length) return;
    var remaining = parseInt(bar.getAttribute('data-fs-remaining'), 10);
    var max = parseInt(bar.getAttribute('data-fs-max'), 10) || 3;
    var shown = parseInt(bar.dataset.fsShown, 10) || max;
    shown = Math.min(Math.max(shown, max), ranked.length);
    bar.dataset.fsShown = shown;

    var list = bar.querySelector('.fs-bar__list');
    var visible = ranked.slice(0, shown);

    visible.forEach(function (c) { list.appendChild(c.el); });
    ranked.forEach(function (c) {
      var show = visible.indexOf(c) !== -1;
      c.el.toggleAttribute('hidden', !show);
      var badge = c.el.querySelector('[data-fs-badge]');
      if (badge) badge.toggleAttribute('hidden', !(c.price >= remaining));
      c.el.classList.toggle('fs-bar__card--unlocks', c.price >= remaining);
    });

    var anyUnlock = visible.some(function (c) { return c.price >= remaining; });
    var promptUnlock = bar.querySelector('[data-fs-prompt-unlock]');
    var promptPartial = bar.querySelector('[data-fs-prompt-partial]');
    if (promptUnlock) promptUnlock.toggleAttribute('hidden', !anyUnlock);
    if (promptPartial) promptPartial.toggleAttribute('hidden', anyUnlock);

    var moreBtn = bar.querySelector('[data-fs-more]');
    if (moreBtn) moreBtn.toggleAttribute('hidden', shown >= ranked.length);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-fs-more]');
    if (!btn) return;
    event.preventDefault();
    var bar = btn.closest('.fs-bar');
    if (!bar) return;
    var max = parseInt(bar.getAttribute('data-fs-max'), 10) || 3;
    var shown = parseInt(bar.dataset.fsShown, 10) || max;
    bar.dataset.fsShown = shown + 3;
    if (bar.__fsRanked) {
      applyRanked(bar);
    } else {
      // Curation hasn't run yet: build a DOM-order ranking so the button
      // still works, then let the next curate() refine it.
      var list = bar.querySelector('.fs-bar__list');
      var remaining = parseInt(bar.getAttribute('data-fs-remaining'), 10);
      bar.__fsRanked = [].map.call(list.querySelectorAll('.fs-bar__card'), function (el) {
        return { el: el, product: parseInt(el.getAttribute('data-fs-product'), 10), price: parseInt(el.getAttribute('data-fs-price'), 10) };
      }).sort(function (a, b) { return (b.price >= remaining) - (a.price >= remaining); });
      applyRanked(bar);
      scheduleCurate();
    }
  });

  /* ---------- Re-curate whenever a bar (re)appears ---------- */

  var debounceTimer = null;
  function scheduleCurate() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(curate, 150);
  }

  function boot() {
    scheduleCurate();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1 && (n.classList && n.classList.contains('fs-bar') || (n.querySelector && n.querySelector('.fs-bar')))) {
            scheduleCurate();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Legacy notification popup watcher ---------- */

  function watchNotification() {
    var slot = document.getElementById('cart-notification-product');
    if (!slot) return;
    new MutationObserver(function () { refreshPopupBar(); }).observe(slot, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watchNotification(); boot(); });
  } else {
    watchNotification();
    boot();
  }
})();
